<script setup>
import { defineProps, defineEmits, watch } from 'vue'
import { state, params } from '@/components/Ajuda/Montador/composables/useBuilderState'
import DecimalField from '@/components/Ajuda/Montador/components/Fields/DecimalField.vue'



const emit = defineEmits(['open-params'])
const props = defineProps({
  // callback opcional; se não vier, emitimos 'open-params'
  openParams: { type: Function, default: null },
})

function openParamsModal() {
  if (typeof props.openParams === 'function') props.openParams()
  else emit('open-params')
}

// --- garante vértices quando entrar no modo livre e liga os handles
function ensureFreeVerts() {
  const has4 = Array.isArray(state.free?.verts) && state.free.verts.length === 4
  if (!has4) {
    const w = Number(state.arenaWm) || Number(params.arena?.w) || 60
    const h = Number(state.arenaHm) || Number(params.arena?.h) || 30
    state.free = state.free || {}
    state.free.verts = [
      { x: 0, y: 0 },
      { x: w, y: 0 },
      { x: w, y: h },
      { x: 0, y: h },
    ]
  }
}

watch(() => state.arenaMode, (mode) => {
  if (mode === 'free') {
    ensureFreeVerts()
    state.free.showHandles = true
  }
}, { immediate: true })

</script>

<template>
  <!-- Botão Parâmetros -->
  <div class="section">
    <button class="btn" @click="openParamsModal">Parâmetros</button>
    <div class="hint">Edite padrões globais: arena, obstáculos (espessuras e vãos), percurso etc.</div>
  </div>

  <!-- Tipo de arena -->
  <div class="section">
    <label class="label">Tipo de arena</label>
    <div class="row">
      <label class="checkbox">
        <input type="radio" value="rect" v-model="state.arenaMode" />
        <span>Retangular</span>
      </label>
      <label class="checkbox">
        <input type="radio" value="free" v-model="state.arenaMode" />
        <span>4 lados (livre)</span>
      </label>
    </div>
  </div>

  <!-- Tamanho da arena -->
  <div class="section">
    <label class="label">Tamanho da arena (m)</label>
    <div class="row">
      <DecimalField v-model.number="state.arenaWm" :step="0.5" label="Largura (W)" />
      <DecimalField v-model.number="state.arenaHm" :step="0.5" label="Altura (H)" />
    </div>
    <div class="hint">Ajuste o retângulo base ou os vértices (modo livre).</div>
  </div>

  <!-- Réguas -->
  <div class="section">
    <label class="label">Réguas</label>
    <label class="checkbox">
      <input type="checkbox" v-model="params.visual.showRulers" />
      <span>Mostrar régua nas bordas</span>
    </label>
  </div>

  <!-- Modo livre: handles e confinamento -->
  <div class="section" v-if="state.arenaMode === 'free'">
    <label class="label">Edição livre</label>
    <label class="checkbox">
      <input type="checkbox" v-model="state.free.showHandles" />
      <span>Mostrar vértices (handles)</span>
    </label>
    <label class="checkbox">
      <input type="checkbox" v-model="state.free.confine" />
      <span>Confinar obstáculos dentro do polígono</span>
    </label>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
